import { Component } from '@angular/core';
import { AuthService } from '../../../shared/service';

@Component({
  selector: 'app-auth0-error',
  templateUrl: './auth0-error.component.html',
  styleUrls: ['./auth0-error.component.scss'],
  standalone :false
})
export class Auth0ErrorComponent {
  constructor(private authService: AuthService) { }

  gotoSignIn() {
    this.authService.logout();
  }
}
